<template>
  <v-container>
    <v-dialog v-model="rewardModal" max-width="400">
      <v-card>
        <v-card-title class="headline">
          Reward Giftcard User
        </v-card-title>
        <v-card-text>
          <v-form @submit.prevent="submitReward">
            <v-text-field v-model="rewardAmount" label="Reward Amount (₦)" type="number" required></v-text-field>
            <v-btn type="submit" color="primary">Reward</v-btn>
            <v-btn @click="rewardModal = false">Cancel</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="rewardModalCrypto" max-width="400">
      <v-card>
        <v-card-title class="headline">
          Reward Crypto User
        </v-card-title>
        <v-card-text>
          <v-form @submit.prevent="submitRewardCrypto">
            <v-text-field v-model="rewardAmountCrypto" label="Reward Amount (₦)" type="number" required></v-text-field>
            <v-btn type="submit" color="primary">Reward</v-btn>
            <v-btn @click="rewardModalCrypto = false">Cancel</v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Top Giftcard Traders
            <v-spacer></v-spacer>
            <v-menu
            v-model="cardMenu"
            style="box-shadow: none"
            :close-on-content-click="false"
            :close-on-click="false"
            :nudge-width="100"
            class="menu dt-border"
            offset-y
            left
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                outlined
                rounded
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-icon> mdi-filter-variant </v-icon>
                filter
              </v-btn>
            </template>
            <v-card class="pa-5" flat>
              <label for="">Date</label>
              <br />
              <DateRangePicker v-model="cardDateRange" />
              <v-card-actions>
                <v-btn rounded depressed @click="reload('card')">Reset</v-btn>
                <v-btn color="primary" @click="getTopTraders()" rounded depressed
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-menu>
            <v-btn color="primary" class="mx-4" @click="downloadCSV('card')">Download Excel</v-btn>
            <v-btn color="primary" @click="submitGiftcardPayment">Upload Payment</v-btn>
          </v-card-title>
          <v-data-table :headers="headers" :items="topTradersUsers" :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus'
          }">
            <template v-slot:item.profilepicture="{ item }">
              <v-avatar size="32" color="grey">
                <img :src="item.profilepicture" />
              </v-avatar>
            </template>
            <template v-slot:item.sn="{ item, index }">
              {{ index + 1 }}
            </template>
            <template v-slot:item.total_loader_amount="{ item }">
              {{ ceilCoin(item.total_loader_amount) }}
            </template>

            <template v-slot:item.action="{ item, index }">
              <v-btn @click="openRewardModal(index)">
                Reward
              </v-btn>
            </template>

          </v-data-table>

        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            Top Crypto Traders
            <v-spacer></v-spacer>
            <v-menu
            v-model="cryptoMenu"
            style="box-shadow: none"
            :close-on-content-click="false"
            :close-on-click="false"
            :nudge-width="100"
            class="menu dt-border"
            offset-y
            left
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                outlined
                rounded
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-icon> mdi-filter-variant </v-icon>
                filter
              </v-btn>
            </template>
            <v-card class="pa-5" flat>
              <label for="">Date</label>
              <br />
              <DateRangePicker v-model="cryptoDateRange" />
              <v-card-actions>
                <v-btn rounded depressed @click="reload('crypto')">Reset</v-btn>
                <v-btn color="primary" @click="loadCryptoTraders()" rounded depressed
                  >Save</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-menu>
            <v-btn color="primary" class="mx-4" @click="downloadCSV('crypto')">Download CSV</v-btn>
            <v-btn color="primary" @click="submitCryptoPayment">Upload Payment</v-btn>
          </v-card-title>
          <v-data-table :headers="cryptoHeaders" :items="cryptoTraders" :footer-props="{
            showFirstLastPage: true,
            firstIcon: 'mdi-arrow-collapse-left',
            lastIcon: 'mdi-arrow-collapse-right',
            prevIcon: 'mdi-minus',
            nextIcon: 'mdi-plus'
          }">
            <template v-slot:item.sn="{ item, index }">
              {{ index + 1 }}
            </template>
            <template v-slot:item.total_loader_amount="{ item }">
              {{ ceilCoin(item.total_loader_amount) }}
            </template>
            <template v-slot:item.profilepicture="{ item }">
              <v-avatar size="32" color="grey">
                <img :src="item.profilepicture" />
              </v-avatar>
            </template>
            <template v-slot:item.action="{ item, index }">
              <v-btn @click="openRewardModalCrypto(index)">
                Reward
              </v-btn>
            </template>
          </v-data-table>

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// =========== IMPORT SERVICE =========
import { PromoService } from "@/services";
import app from '@/main'
import DateRangePicker from "@/components/DateRangePicker.vue";

export default {
  data: () => ({
    cryptoFilter: 'monthly',
    giftFilter: 'monthly',
    topTradersUsers: [],
    cryptoTraders: [],
    rewardModal: false,
    rewardModalCrypto: false,
    rewardAmountCrypto: 0,
    rewardAmount: 0,

    headers: [
      { text: "s/n", value: 'sn' },
      // { text: "First Name", value: "firstname" },
      // { text: "Last Name", value: "lastname" },

      { text: "email", value: "email" },
      { text: "username", value: "username" },
      { text: "reward", value: 'reward' },
      { text: "Points", value: "total_loader_amount" },
      { text: "Action", value: "action" }
    ],

    cryptoHeaders: [
      { text: "s/n", value: 'sn' },
      // { text: "First Name", value: "firstname" },
      // { text: "Last Name", value: "lastname" },

      { text: "email", value: "email" },
      { text: "username", value: "username" },
      { text: "reward", value: 'reward' },
      { text: "Points", value: "total_loader_amount" },
      { text: "Action", value: "action" }
    ],
    cryptoMenu: false,
    cardMenu: false,
    cardDateRange: {
      startDate: null,
      endDate: null,
    },
    cryptoDateRange: {
      startDate: null,
      endDate: null,
    },
  }),
  components: {
    DateRangePicker
  },
  async mounted() {
    this.getTopTraders(this.giftFilter);
    this.loadCryptoTraders(this.cryptoFilter)
  },
  methods: {
    async reset() {
      this.topTradersUsers = [];
      this.cryptoTraders = [];
      this.getTopTraders();
      this.loadCryptoTraders(this.cryptoFilter)
    },

    ceilCoin(item) {
      return Math.ceil(Number(item));
    },
    convertToCSV(objArray) {
      const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
      let str = '';

      // Add header row with field names
      let headerRow = '';
      for (let key in array[0]) {
        if (headerRow !== '') headerRow += ',';
        headerRow += key;
      }
      str += headerRow + '\r\n';

      // Add data rows
      for (let i = 0; i < array.length; i++) {
        let line = '';
        for (let key in array[i]) {
          if (line !== '') line += ',';
          line += array[i][key];
        }
        str += line + '\r\n';
      }

      return str;
    }
    ,
    generateRandomFileName() {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const timestamp = Date.now();
      let randomString = '';
      for (let i = 0; i < 10; i++) {
        randomString += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      return `${randomString}_${timestamp}`;
    },
    downloadCSV(choice) {
      let data = choice == 'card' ? this.topTradersUsers : this.cryptoTraders;
      const csvString = this.convertToCSV(data); // this.data is the object you want to download
      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', `${this.generateRandomFileName()}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async submitGiftcardPayment() {
      if (confirm('are you sure you want to upload')) {
        let promises = [];
        this.topTradersUsers.forEach((user) => {
          console.log(user);
          let data = {
            type: 'giftcard',
            user: user.id,
            amount: Number(user.reward),


          }
          promises.push(PromoService.payReward(data));
        })

        const result = await Promise.all(promises);
        if (result) {
          app.$store.dispatch('toast', {
            message: 'users have been creditted successfully',
            variant: 'success'
          });
         await this.reset();
        }
      }

    },
    async submitCryptoPayment() {
      if (confirm('are you sure you want to upload')) {
        let promises = [];
        this.cryptoTraders.forEach((user) => {
          console.log(user);
          let data = {
            type: 'crypto',
            user: user.id,
            amount: Number(user.reward),


          }
          promises.push(PromoService.payReward(data));
        })

        const result = await Promise.all(promises);
        if (result) {
          app.$store.dispatch('toast', {
            message: 'users have been creditted successfully',
            variant: 'success'
          });
          await this.reset();
        }
      }

    },
    submitReward() {
      this.topTradersUsers[this.selectedUser].reward = this.rewardAmount;
      app.$store.dispatch('toast', {
        message: ' checking record...',
        variant: 'info'
      });
      setTimeout(() => {
        app.$store.dispatch('toast', {
          message: 'Everything is good',
          variant: 'success'
        });
      }, 2000)
      this.rewardModal = false;
      this.rewardAmount = 0;

    },
    submitRewardCrypto() {
      this.cryptoTraders[this.selectedUser].reward = this.rewardAmountCrypto;
      app.$store.dispatch('toast', {
        message: ' checking record...',
        variant: 'info'
      });
      setTimeout(() => {
        app.$store.dispatch('toast', {
          message: 'Everything is good',
          variant: 'success'
        });
      }, 2000)

      this.rewardModalCrypto = false;
      this.rewardAmountCrypto = 0;

    },
    openRewardModal(user) {
      this.selectedUser = user;
      this.rewardModal = true;
      // code to open the modal here
    },
    openRewardModalCrypto(user) {
      this.selectedUser = user;
      this.rewardModalCrypto = true;
      // code to open the modal here
    },
    async getTopTraders() {
      try {
        this.topTradersUsers = [];
        this.loading = true;
        let data = await PromoService.getTopGiftcardTraders(this.cardDateRange);
        this.loading = false;
        this.cardMenu = false;
        this.topTradersUsers = data;
        console.log("trans", data);
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    async loadCryptoTraders() {
      try {
        this.cryptoTraders = [];
        this.loading = true;
        let data = await PromoService.getTopCryptoTraders(this.cryptoDateRange);
        this.loading = false;
        this.cryptoMenu = false;
        this.cryptoTraders = data;
        console.log("trans", data);
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
    reload(type) {
      if (type == 'card') {
        this.cardDateRange = {
          startDate: null,
          endDate: null,
        }
        this.getTopTraders();
      } else {
        this.cryptoDateRange = {
          startDate: null,
          endDate: null,
        }
        this.loadCryptoTraders();
      }
    }
  },
};
</script>